import { ID, BaseEntity } from '../model/baseentity';
import { AppDao } from './appdao';
import { Observable } from 'rxjs';
import { RestQuery, PageData, QueryParams } from '../restquery/restquery';
import { AppRest } from './rest';
import { EntityMeta } from '../meta/entitymetadata';

/**
 * åºæ¬ä¸å¡DAO
 * @export
 */
export class BaseDao<T extends BaseEntity> {
    get appRest(): AppRest {
        return this.appDao.appRest;
    }

    constructor(public appDao: AppDao, public entityName: string) {

    }

    /**
    * æç§IDè·åå®ä½
    * @template T å®ä½ç±»å
    * @param ID id å®ä½ID
    * @returns Observable<T> å®ä½å¯¹è±¡
    * @memberOf EntityBaseDao
    */
    get(id: ID): Observable<T> {
        return this.appDao.get(this.entityName, id);
    }

    /**
    * è·åå®ä½URL,<baseUrl>
    * å¦ææå®äºå®ä½å¯¹è±¡æèIDï¼è¿åï¼&lt;baseUrl&gt;/&lt;id&gt;,
    * å¦ææå®äºæä½ï¼è¿åï¼&lt;baseUrl&gt;/&lt;id&gt;/&lt;op&gt;
    * @param obj å®ä½å¯¹è±¡æèID
    * @param op å®ä½æä½
    */
    getUrl(obj?: T | ID, op?: string): string {
        return this.appDao.getUrl(this.entityName, obj, op);
    }

    /**
     * å®ä½æ¥è¯¢,åæ°æMapææï¼å°ä¼éæ°è§£æä¸ºRestQueryè¿è¡æ¥è¯¢
     * @param params æ¥è¯¢åæ°,ä»¥ä¸é®å¼å°è¢«è§£æä¸ºç¹å®åæ°ï¼å¶ä½é®å¼å°å½åæ¥è¯¢æ¡ä»¶:<br>
     *  first: åé¡µæ¥è¯¢æå®çå¼å§ä½ç½®<br>
     *  rows: åé¡µæ¥è¯¢æ¯é¡µçå¤§å°ï¼å¦æå°äºç­äº0ï¼è¡¨ç¤ºä¸åé¡µ<br>
     *  orderBy: æåºå±æ§ï¼å¦ deptName ascï¼deptName descç­ç­ãå¤ä¸ªäººæåºéè¿éå·è¿è¡åé<br>
     *  sort: æåºè®¾ç½®æ°ç»<br>
     *  limit: éåé¡µæ¥è¯¢ä¸­ï¼è¿åæ°éçéå¶<br>
     *  aggregate: å¯¹æ»¡è¶³æ¡ä»¶çæ°æ®è¿è¡èåç»è®¡<br>
     *  columns: æ¥è¯¢æèç»è®¡çå
     * @see RestQuery
     * @returns PageData
     */
    getEntity(params?: { [prop: string]: any; }): Observable<PageData<T>> {
        return this.appDao.getEntity(this.entityName, params);
    }
    /**
     * å®ä½æ¥è¯¢
     * @param entityName å®ä½åç§°
     * @param params
     * @returns PageData
     */
    getQuery<T>(params: RestQuery): Observable<PageData<T>> {
        return this.appDao.getQuery(this.entityName, params);
    }

    /**
     * æç§æå®æ¡ä»¶æ¥è¯¢å®ä½åè¡¨
     * å¯æå®æå¤§çè¿åè¡æ°
     * @template T å®ä½ç±»å
     * @param QueryPrams} [params] æ¥è¯¢åæ°
     * @param number [limit] è¿åè¡æ°éå¶
     * @returns Observable<T[]> å®ä½åè¡¨
     * @memberOf AppDao
     */
    getList(params?: QueryParams, limit?: number): Observable<T[]> {
        return this.appDao.getList(this.entityName, params, limit)
    }
    /**
     * å®ä½åé¡µæ¥è¯¢
     * @template T å®ä½ç±»å
     * @param number first åé¡µèµ·ç¹
     * @param number rows åé¡µé¡µé¿
     * @param QueryParams params æ¥è¯¢åæ°
     * @returns Observable<PageData<T>> åé¡µç»æ
     * @memberOf AppDao
     */
    getPage(first: number, rows: number, params?: QueryParams): Observable<PageData<T>> {
        return this.appDao.getPage(this.entityName, first, rows, params);
    }
    /**
     * ä¿å­å®ä½å°åå°
     * @template T å®ä½ç±»å
     * @param T obj å®ä½å¯¹è±¡
     * @returns Observable<T> ä¿å­åçå®ä½å¯¹è±¡
     * @memberOf AppDao
     */
    save(obj: T): Observable<T> {
        return this.appDao.save(this.entityName, obj);
    }
    /**
     * å é¤å®ä½
     * @param string entityName å®ä½åç§°
     * @param (aseEntity | ID)} obj å®ä½IDæèå®ä½å¯¹è±¡
     * @returns Observable<void>
     * @memberOf AppDao
     */
    remove(obj: BaseEntity | ID): Observable<void> {
        return this.appDao.remove(this.entityName, obj);
    }

    /**
     * è·åå®ä½åæ°æ®
     */
    getMetadata(flat: boolean): Observable<EntityMeta> {
        return this.appDao.metadataDao.getMetadata(this.entityName,flat);
        // let url = this.getUrl();
        // if (this.appDao.appConfig.metaApiUrl) {
        //     //ä½¿ç¨å¨å±åæ°æ®ï¼å¸¦ç¼å­ï¼
        //     return this.appDao.metadataDao.getMetadata(this.entityName, flat);
        // } else {
        //     return this.appRest.get(`${url}/_metadata?flat=${flat ? '1' : '0'}`);
        // }
    }
}
